module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/global-sign-a1bde79bdf2954f10fae7d0184961d10.png";